import { defineMessages } from 'react-intl';

export const generalMessages = defineMessages({
  repeatPayment: {
    id: 'checkout.cartPage.oalt.repeatPayment',
    defaultMessage: 'Repeat payment',
  },
  returnToPreviousStep: {
    id: 'checkout.cartPage.oalt.returnToCart',
    defaultMessage: 'Close',
  },
  createOrderFailed: {
    id: 'checkout.cartPage.oalt.createOrderFailed',
    defaultMessage:
      "We're sorry, but the order could not be submitted. Please try again later. In case this happens again, please contact our Customer Service at 02 03 769 2779",
  },
});
